import { Fab, styled, Theme } from '@mui/material';
import { CustomButtomProps } from 'v3/shared/components/Button/MiniButton/types';

const baseStyles = (theme: Theme, backgroundColor?: string) => ({
  backgroundColor: backgroundColor || theme.palette.tertiary.main,
  color: theme.palette.common.white,
  fontWeight: 'bold',
  boxShadow: `0rem .3rem 1.2rem ${theme.palette.background.default}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 999,
  opacity: 0.8,
});

export const CircularButtonStyles = styled(Fab)<CustomButtomProps>(({ theme, $backgroundColor }) => ({
  ...baseStyles(theme, $backgroundColor),

  '&.Mui-disabled': {
    ...baseStyles(theme, $backgroundColor),
    opacity: 0.4,
  },
}));
